import {SuiviFacture} from "../../../shared/classes/SuiviFacture";

export default class BudgetLot {
    static db_name = "a17_budget_lots_bgl";

    bgl_id: string = "-1";
    bgl_lot_id: string = "-1";
    bgl_quote_part_terrain_ht: number = 0;
    bgl_quote_part_terrain_ttc: number = 0;
    bgl_quote_part_architecte_indice_tva: number = 0;
    bgl_quote_part_architecte_ht: number = 0;
    bgl_quote_part_construction_ht: number = 0;
    bgl_prix_ht: number = 0;
    bgl_quote_part_construction_indice_tva: number = 0;
    bgl_quote_part_construction_ttc_1: number = 0;
    bgl_quote_part_construction_ttc_2: number = 0;
    bgl_quote_part_architecte_ttc_1: number = 0;
    bgl_quote_part_architecte_ttc_2: number = 0;
    bgl_prix_ttc_1: number = 0;
    bgl_prix_ttc_2: number = 0;
    bgl_taux_tva_1: number = 3;
    bgl_taux_tva_2: number = localStorage.getItem('tauxNormalTva') ? Number(localStorage.getItem('tauxNormalTva')) : 17;
    bgl_montant_tva_1: number = 0;
    bgl_montant_tva_2: number = 0;

    bgl_prix_vente_index = 0;
    bgl_construction = 0;
    bgl_construction_ht = 0;
    bgl_base_reduite = 0;
    bgl_tva_reduite = 0;
    bgl_base_normal = 0;
    bgl_tva_normale = 0;

    bg_calcul_prix: number = 0;
    bgl_realise_a = 0;
    bgl_frais_architecte = 0;
    bgl_construction_a_realiser;
    bgl_construction_realisee;
    bgl_quote_part_architecte_payee;
    bgl_quote_part_architecte_a_payer;

    bgl_ind_id;
    bgl_ind_indice;
    bgl_taxe_paye;
    bgl_taxe_paye_ttc;

    bgl_indice_qpt;
    bgl_indice_qpa;
    bgl_indice_qpc;

    bgl_qpt_facture;
    bgl_variation: number = 0;
    bgl_type_variation: 'numeraire' | 'pourcentage' = 'numeraire';
    bgl_milliemes: number = 0.000;

    bgl_facture_com_terrain;
    bgl_facture_com_construction;

    bgl_nombre_indice: number = 0;
    bgl_pourcentage_max_indice: number = 0;
    bgl_dernier_ind_id: number;
    bgl_dernier_ind_indice: number;

    suivi_facture: SuiviFacture[] = [];

    ventilation?: boolean = null;
    from_simulation?: boolean = null;

    constructor(init?: Partial<BudgetLot>) {
        Object.assign(this, init);

        
        return this;
    }
}
